/**
 * Lock background body element when you have a modal pop-up.
 * Prevents the background from be scrolled and fixes body to be fixed
 */
export function lockBackgroundScrolling(): void {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  if (scrollY) {
    const body = document.body;
    body.style.overflow = 'hidden';
    body.style.top = `-${scrollY}`;
  }
}

/**
 * Unlock background scrolling on body when a modal pop-up closes.
 */
export function unlockBackgroundScrolling(): void {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  body.style.overflow = 'auto';
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
}

/**
 * Scrolls Into view by given fragment element ID
 * @param fragment element ID to scroll into view
 * @param blockParam - dom block scroll to parameters.
 * @param inlineParam - optional inline param
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
 * Block can be 'nearest', 'start', etc...
 */
export function scrollIntoView(fragment: string, blockParam: any, inlineParam?: any): void {
  const linkFragment = document.getElementById(fragment) as HTMLElement;
  if (linkFragment) {
    if (inlineParam) {
      linkFragment.scrollIntoView({ behavior: 'smooth', block: blockParam, inline: inlineParam });
    } else {
      linkFragment.scrollIntoView({ behavior: 'smooth', block: blockParam });
    }
  }
}

/**
 * Scrolling window position to top
 */
export function scrollToTopScrolling(): void {
  document.body.scrollIntoView({ behavior: 'smooth' });
}

/**
 * Scroll to position
 * @param yOffset - offset the y position
 * @param fragment - element ID to scroll into view
 */
export function scrollToPosition(yOffset: number, fragment: string): void {
  const element = document.getElementById(fragment);
  // need to add the element check else it throw undefined
  if (element) {
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}
